import { useCallback, useEffect, useState } from 'react';
import { get } from '../api';

export type InstrumentFreshness = {
    instrument: string;
    feed: string | null;
    primary_timeframe: string | null;
    last_time: string | null;
    age_seconds: number | null;
    timeframe_count: number;
    status: 'fresh' | 'stale' | 'very_stale' | 'missing';
};

export function useInstrumentStatus() {
    const [instruments, setInstruments] = useState<InstrumentFreshness[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const refresh = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await get('/instruments/status');
            if (!response.ok) throw new Error(`Request failed (${response.status})`);
            setInstruments(await response.json());
        } catch (requestError) {
            setError(requestError instanceof Error ? requestError.message : 'Failed to load instrument status');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return { instruments, isLoading, error, refresh };
}
